<template>
  <div class="login-wrap">
    <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm login-container">
      <div class="login-margin">
        <div class="title" :class="{'not-choose':!isLoginChoose}" @click="changeChoose">登录</div>
        <div class="title" :class="{'not-choose':isLoginChoose}" @click="changeChoose">注册</div>
      </div>
      <!-- 登录页 -->
      <div v-if="isLoginChoose">
        <el-row class="small-title">
          <!-- <el-col :span="12">
          <div :class="{'grey':!isPhoneLogin}" @click="changeChoosePhone">手机号登录</div>
        </el-col> -->
        </el-row>
        <el-form-item prop="factoryName" v-if="!isPhoneLogin">
          <el-input type="text" v-model="ruleForm.factoryName" auto-complete="off" placeholder="工厂名称"></el-input>
        </el-form-item>
        <el-form-item prop="phoneNum">
          <el-input type="text" v-model="ruleForm.phoneNum" auto-complete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"></el-input>
        </el-form-item>
        <el-checkbox class="remember" v-model="rememberpwd">保持登录</el-checkbox>
        <el-form-item style="width:100%;">
          <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')" :loading="logining">登录</el-button>
        </el-form-item>
      </div>
      <!-- 注册页 -->
      <div v-if="!isLoginChoose">
        <el-row class="small-title">
          <!-- <el-col :span="12">
          <div :class="{'grey':!isPhoneLoginReg}" @click="changeChoosePhoneReg">手机号注册</div>
        </el-col> -->
        </el-row>
        <el-form-item prop="factoryName">
          <el-input type="text" v-model="ruleForm.factoryName" auto-complete="off" placeholder="工厂名称"></el-input>
        </el-form-item>
        <el-form-item prop="phoneNum">
          <el-input type="text" v-model="ruleForm.phoneNum" auto-complete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item style="width:100%;">
          <el-button type="primary" style="width:100%;" @click="submitRegister('ruleForm')" :loading="logining">注册</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script type="text/ecmascript-6">
import { login,register} from '../api/userMG';
import { setCookie, getCookie, delCookie } from '../utils/util';
import md5 from 'js-md5';
import { phoneRule} from '@/utils/regMatch';
export default {
  name: 'login',
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //phoneNum和password默认为空
        phoneNum: '',
        password: '',
        factoryName:'',
        from:'web'
      },
      //rules前端验证
      rules: {
        factoryName: [{ required: true, message: '请输入工厂名称', trigger: 'blur' }],
        phoneNum: [{ required: true, validator: phoneRule, trigger: ['blur','change'] }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      isLoginChoose:true,
      isPhoneLogin:true,
      isLoginChooseReg:true,
      isPhoneLoginReg:true,

    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取存在本地的用户名密码
    this.getuserpwd()

  },
  // 里面的函数只有调用才会执行
  methods: {
    changeChoose(){
      this.isLoginChoose = !this.isLoginChoose;
      this.resetForm()
    },
    resetForm(options){
      this.$refs['ruleForm'].resetFields();
      this.ruleForm.phoneNum = ''
      this.ruleForm.password = ''
      this.ruleForm.factoryName = ''
      if(options == 'clear'){
        this.isLoginChoose = true
      }
    },
    changeChoosePhone(){
      this.isPhoneLogin = !this.isPhoneLogin;
      this.resetForm()
    },
    changeChooseReg(){
      this.isLoginChooseReg = !this.isLoginChooseReg;
    },
    changeChoosePhoneReg(){
      this.isPhoneLoginReg = !this.isPhoneLoginReg;
      this.resetForm()
    },
    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.phoneNum = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    submitRegister(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          register(this.ruleForm).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.isLoginChoose = true
              this.resetForm('clear')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // this.logining = true
          // 测试通道，不为空直接登录
          // setTimeout(() => {
          //   this.logining = false
          //   this.$store.commit('login', 'true')
          //   this.$router.push({ path: '/goods/Goods' })
          // }, 1000)
          // 注释
          login(this.ruleForm).then(res => {
            if (res.code == 200 && res.data) {
              if (this.rememberpwd) {
                //保存帐号到cookie，有效期7天
                setCookie('user', this.ruleForm.phoneNum, 7)
                //保存密码到cookie，有效期7天
                setCookie('pwd', this.ruleForm.password, 7)
              } else {
                delCookie('user')
                delCookie('pwd')
              }
              //如果请求成功就让他2秒跳转路由
              setTimeout(() => {
                this.logining = false
                // 缓存token
                // localStorage.setItem('logintoken', res.data.token)
                // 缓存用户个人信息
                localStorage.setItem('userdata', JSON.stringify(res.data))
                this.$store.commit('login', 'true')
                // 弹出登录成功
                this.$message({
                  message: '登录成功',
                  type: 'success'
                })
                this.$router.push({ path: '/home/Home' })
              }, 1000)
            } else {
              this.$message.error(res.msg)
              this.logining = false
              return false
            }
          })
        } else {
          this.$message.error('请输入用户名密码！')
          this.logining = false
          return false
        }
      })
    },
  }
}
</script>

<style scoped>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 10%;
  background-image: url(../assets/img/bg.png);
  width: 1920px;
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}
.login-container {
  position: relative;
  left:12%;
  border-radius: 10px;
  width: 350px;
  padding: 40px 35px 30px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}
.remember {
  margin: 0px 0px 35px 0px;
}
.login-wrap .title{
  display: inline-block;
  width: 41%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 12px 15px;
  color: #fff;
  cursor: pointer;
  color: #1890ff;
  border-bottom: 1px solid #1890ff;
}
.login-wrap .not-choose{
  border-bottom: none;
  color: #1f273d;
}
.login-margin{
  margin-bottom: 30px;
}
.text-align-right{
  text-align: right;
}
.login-wrap .small-title{
  font-size: 12px;
  margin-bottom: 15px;
  cursor: pointer;
}
.login-wrap .small-title .grey{
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue